<main
  class="container"
  style="overflow: hidden; -ms-overflow-style: none"
  [ngClass]="{
    'max-width-1200-px':
      SharedDataService.data.pointOfLease.flow !== 'inactive' && SharedDataService.data.pointOfLease.flow !== 'eRenterPlan',
    'max-width-1500-px':
      (SharedDataService.data.pointOfLease && SharedDataService.data.pointOfLease.flow === 'inactive') ||
      SharedDataService.data.pointOfLease.flow === 'eRenterPlan'
  }"
>
  <div class="row">
    <div class="col-12">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>
